import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { CSSTransition } from 'react-transition-group';

const DEFAULT_TRANSITION_TIMEOUT = { enter: 500, exit: 300 };

const Fade = ({
  out,
  in: inProp,
  children,
  timeout = DEFAULT_TRANSITION_TIMEOUT,
  className,
}) => {
  return (
    <CSSTransition
      classNames={cn('CSSTransition fade', className)}
      timeout={timeout}
      in={inProp}
      out={out}
      unmountOnExit
    >
      {children}
    </CSSTransition>
  );
};

Fade.propTypes = {
  out: PropTypes.bool,
  in: PropTypes.bool,
  children: PropTypes.node,
  timeout: PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number,
  }),
  className: PropTypes.string,
};

export default Fade;
